module.exports = __webpack_public_path__ + "assets/icon-check-blue.01e2a132.svg";